/**
 * API Token API Client
 *
 * Handles CRUD operations for personal access tokens.
 */

import type { AxiosResponse } from 'axios'
import axios from 'axios'
import type {
	ApiTokenStorePayload,
	ApiTokenStoreResponse,
	ApiTokenListResponse,
} from '@/models/ApiToken/Types'

const apiUrl = import.meta.env.VITE_API_URL

export default class ApiTokenApi {
	/**
	 * List all API tokens for the current user.
	 */
	async list(): Promise<AxiosResponse<ApiTokenListResponse>> {
		return await axios.get(`${apiUrl}/api-tokens`)
	}

	/**
	 * Create a new API token.
	 */
	async store(params: ApiTokenStorePayload): Promise<AxiosResponse<ApiTokenStoreResponse>> {
		return await axios.post(`${apiUrl}/api-tokens`, params)
	}

	/**
	 * Delete an API token.
	 */
	async destroy(id: string): Promise<AxiosResponse<{ message: string }>> {
		return await axios.delete(`${apiUrl}/api-tokens/${id}`)
	}
}
